// Small pure helpers over the rows of a cart (`cart.products`). Tested.

/**
 * A unique key of a cart row: product (or bundle), variant keys and price key. The same three parts core builds inline
 * to find a row (`useProduct`, with `-` and a `null` text); this one is for a site's own maps. (jument `helpers/presale.js`)
 */
export const cart_row_key = (row) =>
	`${row?.bundle_id || row?.product_id}|${(row?.mix_variant_keys || []).toString()}|${row?.price_key || ""}`;

/** A cart row → the input of removeFromCart / one entry of removeAllFromCart. (chawk-bazar / ciseco / jument `_useClearCart.js`) */
export const to_cart_remove_input = (row) => ({
	product_id: row?.product_id || undefined,
	bundle_id: row?.bundle_id || undefined,
	mix_variant: row?.mix_variant_keys || [],
	price_key: row?.price_key || null,
});
